import { generateSmartGame } from "./generateSmartGame.js";

export const employmentGame = generateSmartGame("employee");

export const studentGame = generateSmartGame("student");
